<pr-form
  [noSubmitBtn]="true"
  (onSubmit)="submit()"
  [title]="title"
  [formGroup]="form"
>
  <h3 class="drawer-title">Quel revenu voulez-vous ajouter ?</h3>
  <ul>
    <li>
      <pr-button
        clazz="lg neutral choose-button"
        tooltips="Salaire"
        label="Salaire"
        (onClick)="startForm('SALARY')"
      ></pr-button>
    </li>
    <li>
      <pr-button
        clazz="lg neutral choose-button"
        tooltips="Retraite"
        label="Retraite"
        (onClick)="startForm('RETIREMENT')"
      ></pr-button>
    </li>
    <li>
      <pr-button
        clazz="lg neutral choose-button"
        tooltips="BNC"
        label="BNC"
        (onClick)="startForm('BNC')"
      ></pr-button>
    </li>
    <li>
      <pr-button
        clazz="lg neutral choose-button"
        tooltips="BIC"
        label="BIC"
        (onClick)="startForm('BIC')"
      ></pr-button>
    </li>
    <li>
      <pr-button
        clazz="lg neutral choose-button"
        tooltips=" BA"
        label="BA"
        (onClick)="startForm('BA')"
      ></pr-button>
    </li>
    <li>
      <pr-button
        clazz="lg neutral choose-button"
        tooltips="Pension"
        label="Pension"
        (onClick)="startForm('PENSION')"
      ></pr-button>
    </li>
    <li>
      <pr-button
        clazz="lg neutral choose-button"
        tooltips="Revenus de capitaux mobiliers"
        label="Revenus de capitaux mobiliers"
        (onClick)="startForm('DIVIDEND')"
      ></pr-button>
    </li>
  </ul>
</pr-form>
